var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"CHANNEL_DOWN","name":"CHANNEL_DOWN","data-vcode":"CHANNEL_DOWN"}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icn-channel-down.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('channelDown')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }